const orgin = window.location.origin;
const pathname = window.location.pathname;

export default {
  front_base: orgin + pathname,
}